import suiteService from 'qreventos-suite/services';
import invitacionService from 'qreventos-suite/invitaciones';

class SuiteConfig {
    evento:number = 775;
    token:string = 'bUJldXJDYnNJRVdFdVVCL3FnbmI4STNneDZuYncvaUZnVTl4cU9kQjlXaz0=';
    clientId: string = '718f10cb-6f9b-4494-a587-44dfcd7a830e-775';

    public constructor() {
      suiteService.clientId = this.clientId;
      suiteService.token = this.token;  

      invitacionService.clientId = this.clientId;
      invitacionService.token = this.token;
    }
}

export default new SuiteConfig();
